export default __webpack_public_path__ + "static/media/Across-Boba-Color30x30.7633ad07.svg";